import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import 'lodash-es';
import { ToastNotification } from 'carbon-components-react';
import { IlIcon } from '../../IlIcon/index.js';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';
import { NOTIFICATION_ICON_KIND } from '../constants.js';

var _excluded = ["kind", "withToastify"];
var BASE_CSS = "".concat(cssClassPrefix, "-toast-notification");
var IlToastNotification = /*#__PURE__*/function (_Component) {
  function IlToastNotification() {
    var _this;
    _classCallCheck(this, IlToastNotification);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IlToastNotification, [].concat(args));
    _defineProperty(_this, "state", {
      open: true
    });
    _defineProperty(_this, "handleCloseButtonClick", function (evt) {
      _this.setState({
        open: false
      });
      _this.props.onCloseButtonClick(evt);
    });
    return _this;
  }
  _inherits(IlToastNotification, _Component);
  return _createClass(IlToastNotification, [{
    key: "render",
    value: function render() {
      if (!this.state.open) {
        return null;
      }
      var _this$props = this.props,
        kind = _this$props.kind,
        withToastify = _this$props.withToastify,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React__default.createElement("div", {
        className: BASE_CSS
      }, withToastify && /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(BASE_CSS, "__cover")
      }), /*#__PURE__*/React__default.createElement(IlIcon, {
        name: NOTIFICATION_ICON_KIND[kind],
        className: "".concat(BASE_CSS, "__icon ").concat(BASE_CSS, "__icon--").concat(kind)
      }), /*#__PURE__*/React__default.createElement(ToastNotification, _extends({
        kind: kind === 'loading' ? 'info' : kind
      }, rest, {
        onCloseButtonClick: this.handleCloseButtonClick
      })));
    }
  }]);
}(Component);
_defineProperty(IlToastNotification, "propTypes", {
  children: PropTypes.node,
  className: PropTypes.string,
  kind: PropTypes.oneOf(['success', 'info', 'warning', 'error', 'loading']),
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  role: PropTypes.string,
  caption: PropTypes.node,
  onCloseButtonClick: PropTypes.func,
  iconDescription: PropTypes.string,
  notificationType: PropTypes.oneOf(['inline', 'toast']),
  hideCloseButton: PropTypes.bool,
  timeout: PropTypes.number,
  withToastify: PropTypes.bool
});
_defineProperty(IlToastNotification, "defaultProps", {
  kind: 'error',
  role: 'alert',
  notificationType: 'toast',
  iconDescription: 'closes notification',
  onCloseButtonClick: function onCloseButtonClick() {},
  hideCloseButton: false,
  timeout: 0
});

export { IlToastNotification as default };
